<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="columns onboarding-create-site__step4">
    <div
      class="column is-5 onboarding-create-site__img onboarding-create-site__img--step4 is-hidden-mobile"
      :style="`background-image: url(${imgNoivosFeliz})`"
    ></div>
    <div class="column has-text-centered onboarding-create-site__description">
      <div class="onboarding-create-site__description--width-80">
        <h1 class="onboarding-create-site__title has-text-weight-bold">
          E o que gostariam de comunicar no site?
        </h1>
        <p>É possível selecionar mais de uma opção 😉</p>
        <AnswersRectangle :options="options" />
      </div>
      <buttonsNext :stepNumber="stepNumber" />
    </div>
  </div>
</template>

<script>
import verifyOnboardingCompleteMixin from '@/mixins/verifyOnboardingCompleteMixin'

import buttonsNext from '@/components/OnboardingCreationSite/ButtonsNext.vue'
import AnswersRectangle from '@/components/OnboardingCreationSite/OptionsAnswersRectangle.vue'
import imgNoivosFeliz from '@/assets/img/onboarding-create-site/casal-feliz.jpg'

export default {
  mixins: [verifyOnboardingCompleteMixin],

  components: {
    buttonsNext,
    AnswersRectangle,
  },

  props: {
    stepNumber: Number,
  },

  data() {
    return {
      imgNoivosFeliz,
      options: [
        {
          id: 0,
          checked: false,
          text: 'Sobre o casal',
          value: 'sobre_casal',
        },
        {
          id: 1,
          checked: false,
          text: 'Local da cerimônia',
          value: 'local_cerimonia',
        },
        {
          id: 2,
          checked: false,
          text: 'Local da festa',
          value: 'local_festa',
        },
        {
          id: 3,
          checked: false,
          text: 'Sobre os padrinhos',
          value: 'padrinhos',
        },
        { id: 4, checked: false, text: 'Mural de recados', value: 'recados' },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.onboarding-create-site {
  &__step4 {
    display: flex;
    min-height: fit-content;
  }

  &__img {
    &--step4 {
      margin-top: 12px;
    }
  }

  &__description {
    &--width-80 {
      @media (min-width: $tablet) {
        max-width: 90%;
        margin: 0 auto;
      }
    }
  }
}
</style>
